const config = {
  //server_ip: "http://localhost:4000/",
  server_ip: "https://api.encontrosdaprimavera.com/",
};

export default config;
